import { useState } from 'react';
import {
  getBusinessPartnerTypeDropdown,
  getBusinessPartnerCABIEStatusDropdown,
  getBusinessPartnerDBStatusDropdown,
} from '../../api/businessPartnerFilters';
import FilterField from '../LoadFilters/FilterField';
import {
  getMinDate,
  getMaxDate,
  hasAnyFilterSelected,
  getFilterMinLengthError,
  hasFilterMinLengthErrors,
} from '../LoadFilters/utils';
import PropTypes from 'prop-types';

const styles = {
  fields: 'd-flex gap-4 justify-content-between',
  column: 'd-flex flex-column gap-2 flex-grow-1',
  dateField: 'd-flex gap-2',
};

const initialDropdownOptions = {
  types: [],
  cabieStatuses: [],
  dbStatuses: [],
};

const toOptions = (arr, idKey = 'id', dataKey = 'data') => {
  const list = Array.isArray(arr) ? arr : (arr?.data ?? arr?.results ?? []);
  return list
    .filter((item) => (item[dataKey] ?? item.status ?? item.data) != null)
    .map((item) => ({
      id: item[dataKey] ?? item.status ?? item.id,
      data: item[dataKey] ?? item.status ?? String(item.id),
    }));
};

const BusinessPartnerFilters = ({ visible, values, onChange, onSubmit }) => {
  const [dropdownOptions, setDropdownOptions] = useState(initialDropdownOptions);

  const fetchTypeDropdown = () => {
    getBusinessPartnerTypeDropdown().then((res) => {
      setDropdownOptions((prev) => (prev.types.length > 0 ? prev : { ...prev, types: toOptions(res) }));
    });
  };
  const fetchCABIEStatusDropdown = () => {
    getBusinessPartnerCABIEStatusDropdown().then((res) => {
      setDropdownOptions((prev) => (prev.cabieStatuses.length > 0 ? prev : { ...prev, cabieStatuses: toOptions(res) }));
    });
  };
  const fetchDBStatusDropdown = () => {
    getBusinessPartnerDBStatusDropdown().then((res) => {
      setDropdownOptions((prev) => (prev.dbStatuses.length > 0 ? prev : { ...prev, dbStatuses: toOptions(res) }));
    });
  };

  const handleChange = (e) => {
    onChange((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  if (!visible) return null;

  const applyDisabled = !hasAnyFilterSelected(values) || hasFilterMinLengthErrors(values);

  return (
    <div className="px-3 mt-4">
      <div className={styles.fields}>
        <div className={styles.column}>
          <FilterField
            label="COMPANY NAME"
            field="companyName"
            value={values.companyName}
            onChange={handleChange}
            error={getFilterMinLengthError('companyName', values.companyName)}
          />
          <FilterField
            label="EORI NUMBER"
            field="eori"
            value={values.eori}
            onChange={handleChange}
            error={getFilterMinLengthError('eori', values.eori)}
          />
        </div>
        <div className={styles.column}>
          <FilterField
            label="TYPE"
            field="type"
            value={values.type}
            options={dropdownOptions.types}
            onChange={handleChange}
            onDropdownOpen={fetchTypeDropdown}
          />
          <FilterField
            label="CABIE STATUS"
            field="cabieStatus"
            value={values.cabieStatus}
            options={dropdownOptions.cabieStatuses}
            onChange={handleChange}
            onDropdownOpen={fetchCABIEStatusDropdown}
          />
          <FilterField
            label="DB STATUS"
            field="dbStatus"
            value={values.dbStatus}
            options={dropdownOptions.dbStatuses}
            onChange={handleChange}
            onDropdownOpen={fetchDBStatusDropdown}
          />
        </div>
        <div className={styles.column}>
          <div className={styles.dateField}>
            <FilterField
              type="date"
              label="LAST UPDATED"
              field="lastModifiedFrom"
              value={values.lastModifiedFrom}
              onChange={handleChange}
              min={values.lastModifiedTo ? getMinDate(values.lastModifiedTo) : undefined}
              max={values.lastModifiedTo || undefined}
            />
            <FilterField
              type="date"
              field="lastModifiedTo"
              value={values.lastModifiedTo}
              onChange={handleChange}
              min={values.lastModifiedFrom || undefined}
              max={values.lastModifiedFrom ? getMaxDate(values.lastModifiedFrom) : undefined}
            />
          </div>
        </div>
      </div>
      <div className="text-end">
        <button className="stepper-button yellow" onClick={onSubmit} disabled={applyDisabled}>
          Apply Filter
        </button>
      </div>
    </div>
  );
};

BusinessPartnerFilters.propTypes = {
  visible: PropTypes.bool,
  values: PropTypes.shape({
    companyName: PropTypes.string,
    eori: PropTypes.string,
    type: PropTypes.string,
    cabieStatus: PropTypes.string,
    dbStatus: PropTypes.string,
    lastModifiedFrom: PropTypes.string,
    lastModifiedTo: PropTypes.string,
  }),
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default BusinessPartnerFilters;
